import { defineStore } from "pinia";
import { zoneService } from "@/_services";

export const zoneStore = defineStore("zone", {
  state: () => ({
    zones: null,
    zonesExport: null,
    zone: null,
    zoneCreated: null,
    zoneUpdated: null,
    zoneDeleted: null,
    error: null,
  }),

  actions: {
    getZones(pagination, query, sort) {
      this.error = null;
      zoneService
        .getZones(pagination, query, sort)
        .then((result) => {
          this.zones = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.zonesExport = null;
      return zoneService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.zonesExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getZoneById(zone_id) {
      this.error = null;
      this.zone = null;
      zoneService
        .getZoneById(zone_id)
        .then((result) => {
          this.zone = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    createZone(data) {
      this.error = null;
      this.zoneCreated = null;
      zoneService
        .createZone(data)
        .then((result) => {
          this.zoneCreated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    updateZone(data, zone_id) {
      this.error = null;
      this.zoneUpdated = null;
      zoneService
        .updateZone(data, zone_id)
        .then((result) => {
          this.zoneUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    deleteZone(zone_ids) {
      this.error = null;
      this.zoneDeleted = null;
      zoneService
        .deleteZone(zone_ids)
        .then((result) => {
          this.zoneDeleted = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
  },
});
